import * as React from 'react';
import {flow, forEach} from 'lodash';
import {Field, formValueSelector, InjectedFormProps} from 'redux-form';
import {connect} from 'react-redux';
import {IStore} from '../../../../redux/IStore';
import {bindActionCreators} from 'redux';
import {actions as quoteActions} from '../../../../services/quote/reducer';
import {Button, Col, ControlLabel, FormGroup, HelpBlock, Modal, Row} from 'react-bootstrap';
import TitleField from '../../../../components/TitleField';
import {isRequired} from '../../../../util/validators';
import FieldFormControl from '../../../../components/FieldFormControl';
import {CheckboxField} from '../../../../components/CheckboxGroup/components/CheckboxField';
import {IDriver} from '../../../../data/api/models';
import {lowerCase} from '../../../../util/helpers';

interface ICreateDriverButtonProps extends InjectedFormProps {
  dispatch: any;
  change: any;
  callback: any;
  tempDriver: any;
  drivers: IDriver[];
}

interface ICreateDriverButtonState {
  show: boolean;
  error: string;
}

const isMissingValues = (value) => !value.title || !value.firstName || !value.lastName;

class CreateDriverButton extends React.Component<ICreateDriverButtonProps, ICreateDriverButtonState> {
  public state = {
    show: false,
    error: '',
  };

  public componentWillReceiveProps(nextProps) {
    const { drivers } = this.props;
    let hasError = false;

    if (
      nextProps.tempDriver.title !== this.props.tempDriver.title ||
      nextProps.tempDriver.firstName !== this.props.tempDriver.firstName ||
      nextProps.tempDriver.lastName !== this.props.tempDriver.lastName ||
      nextProps.tempDriver.hasNoNameYet !== this.props.tempDriver.hasNoNameYet
    ) {
      if (nextProps.tempDriver.title && nextProps.tempDriver.firstName && nextProps.tempDriver.lastName) {
        this.setState({ error: '' });
      }
      if (drivers.length > 0) {
        forEach(drivers, (driver) => {
          if (
            driver.title === nextProps.tempDriver.title &&
            driver.firstName === nextProps.tempDriver.firstName &&
            driver.lastName === nextProps.tempDriver.lastName
          ) {
            hasError = true;
          }
        });
      }
    }
    if (!hasError) {
      this.setState({ error: '' });
    }
  }

  public hasIdenticalDriver() {
    const { drivers, tempDriver } = this.props;
    let foundDriver = false;

    forEach(drivers, (driver) => {
      if (
        lowerCase(driver.title) === lowerCase(tempDriver.title) &&
        lowerCase(driver.firstName) === lowerCase(tempDriver.firstName) &&
        lowerCase(driver.lastName) === lowerCase(tempDriver.lastName)
      ) {
        this.setState({ error: 'An existing driver was found with this details.' });
        foundDriver = true;
      }
    });

    return foundDriver;
  }

  public handleCreateDriver = () => {
    const { tempDriver, callback } = this.props;

    const noName = tempDriver.hasNoNameYet;
    const nameFieldValues = {
      title: tempDriver.title,
      firstName: tempDriver.firstName,
      lastName: tempDriver.lastName,
    };

    const shouldThrowError = isMissingValues(nameFieldValues) && !noName;
    const shouldAllowSubmit = (!isMissingValues(nameFieldValues) && !this.hasIdenticalDriver()) || noName;

    if (shouldThrowError) {
      this.setState({ error: 'All fields are required.' });
    }

    if (shouldAllowSubmit) {
      callback(nameFieldValues);
      this.handleClose();
    }
  }

  public handleOpen = () => {
    this.setState({
      show: true,
    });
  }

  public handleClose = () => {
    const { dispatch, change } = this.props;

    dispatch(change('tempDriver.title', ''));
    dispatch(change('tempDriver.firstName', ''));
    dispatch(change('tempDriver.lastName', ''));
    this.setState({
      show: false,
    });
  }

  public handleNoName = () => {
    const { dispatch, change } = this.props;

    dispatch(change('tempDriver.title', ''));
    dispatch(change('tempDriver.firstName', ''));
    dispatch(change('tempDriver.lastName', ''));
  }

  public render() {
    const { tempDriver } = this.props;
    const { show, error } = this.state;
    const showError = error && !tempDriver.hasNoNameYet;

    return (
      <>
        <Button
          bsStyle="primary"
          className="btn-postcode"
          type="button"
          onClick={this.handleOpen}
        >
          Add New Driver
        </Button>

        <Modal show={show} bsSize="large" onHide={this.handleClose} className="sidebar-modal-primary">
          <Modal.Header closeButton={true}>
            <div className="title-no-border">Add Driver</div>
          </Modal.Header>
          <Modal.Body>
            <div className="contact-modal-container">
              <FormGroup controlId={'customer'}>
                <Row>
                  <Col
                    sm={2}
                    style={{ paddingRight: '15px' }}
                  >
                    <TitleField
                      name={'tempDriver.title'}
                      type="adult"
                      disabled={tempDriver.hasNoNameYet}
                    />
                  </Col>
                  <Col sm={5} style={{ paddingRight: '15px' }}>
                    <Field
                      type="text"
                      placeholder="Forename"
                      name={'tempDriver.firstName'}
                      component={FieldFormControl}
                      disabled={tempDriver.hasNoNameYet}
                    />
                  </Col>
                  <Col sm={5}>
                    <Field
                      type="text"
                      placeholder="Surname"
                      name={'tempDriver.lastName'}
                      component={FieldFormControl}
                      disabled={tempDriver.hasNoNameYet}
                    />
                  </Col>
                </Row>
              </FormGroup>
              <Row>
                <Col sm={12}>
                  <FormGroup controlId="no_name">
                    <div className="checkbox-payment">
                      <Field
                        name="tempDriver.hasNoNameYet"
                        type="checkbox"
                        component={FieldFormControl}
                        onChange={this.handleNoName}
                      >
                        <div />
                        <span>Don't have driver name yet</span>
                      </Field>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            </div>
            {showError && <div className="error-box">Error: {this.state.error}</div>}
          </Modal.Body>
          <Modal.Footer>
            <Button
              bsStyle="primary"
              className="pull-left"
              onClick={this.handleCreateDriver}
            >
              Create Driver
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');
    return component;
  },
  connect(
    (state: IStore) => {
      const tempDriver = selector(state, 'tempDriver');
      const drivers = selector(state, 'drivers');

      return {
        quote: state.quote,
        tempDriver,
        drivers,
      };
    },
    (dispatch) => ({
      actions: {
        quote: bindActionCreators({...quoteActions}, dispatch),
      },
    }),
  ),
])(CreateDriverButton);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/components/CreateDriverButton/index.tsx